export default __webpack_public_path__ + "static/media/prictable-bg.8f789002.png";